// @ts-check
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Option, OptionValues } from 'react-select'; // eslint-disable-line no-unused-vars
import api from 'utils/api';
import AutoSelect from 'shared/components/Select';

/** @typedef {{
  value?: Option<OptionValues>,
  onChange: (newValue: Option<OptionValues>) => void,
  zip?: string,
  className?: string
}} PlainCountySelectionPropsType */

/** @typedef {{
  fetchingZip?: string,
  counties: Array<{fipsCode: string, name: string}>
}} PlainCountySelectionStateType */

/** @augments { Component<PlainCountySelectionPropsType, PlainCountySelectionStateType> } */
class PlainCountySelection extends Component {
  constructor(props) {
    super(props);
    this.state = { fetchingZip: null, counties: null };
  }

  componentDidMount() {
    this.fetchCounties(this.props.zip);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.zip !== this.props.zip) {
      this.fetchCounties(this.props.zip);
    }
  }

  fetchCounties(zip) {
    if (zip && zip.length === 5) {
      this.setState({ fetchingZip: zip, counties: null });
      api
        .get('/shared/api/counties', {
          params: {
            zip,
          },
        })
        .then(response => {
          if (this.state.fetchingZip === zip) {
            this.setState({ fetchingZip: null, counties: response.data });
          }
        });
    }
  }

  render() {
    const { value, onChange, className } = this.props;
    return (
      <AutoSelect
        simpleValue
        className={className}
        value={value}
        onChange={onChange}
        isLoading={!!this.state.fetchingZip}
        options={this.state.counties}
        valueKey="fipsCode"
        labelKey="name"
      />
    );
  }
}

PlainCountySelection.displayName = 'PlainCountySelection';

PlainCountySelection.propTypes = {
  zip: PropTypes.string,
};

export default PlainCountySelection;
